<template>
  <div class="pdf_box" v-show="fileType === 'pdf'">
    <div class="pdf_bg">
      <i class="fa fa-refresh accent_color" @click="changePdf" aria-hidden="true"></i>
      <template>
        <iframe class="pdf_iframe" v-show="isShowpdf" :src="src" frameborder="0"></iframe>
        <!--  -->
        <!-- <pdf
          class="pdf_iframe"
          :src="src"
          :page="currentPage"
          @num-pages="pageCount = $event"
          @page-loaded="currentPage = $event"
          @loaded="loadPdfHandler"
        ></pdf>-->
      </template>
      <template>
        <div class="unpdf_Box" v-show="!isShowpdf">
          <div class="file_box">
            <FileUpload
              v-on:chageFile="chageFile"
              v-on:changePercent="changePercent"
              :disable="isLoading"
              :iconName="iconName"
              :accept="accept"
              :loadApi="'uploadInvoice'"
              v-on:updatePdf="updatePdf"
            ></FileUpload>
          </div>
        </div>
      </template>
    </div>
  </div>
</template>
<script>
import pdf from "vue-pdf";
import FileUpload from "@/components/templates/FileUpload.vue";
import {fileuploadApi} from "@/common/api/fileuploadApi";
import {mapGetters} from "vuex";
import {receivableApi} from "@/common/api/receivableApi";

export default {
  components: {
    // pdf,
    FileUpload
  },
  data() {
    return {
      currentPage: 1,
      pageCount: 1,
      fileType: "pdf",
      src: "",
      form: { url: "" },
      accept: "pdf",
      iconName: "fa-file-text",
      videoUploadPercent: 0,
      isLoading: false,
      isShowpdf: true,
      pdfUrl: ""
    };
  },

  beforeMount() {
    if (this.pdfUrl) {
      this.src = pdf.createLoadingTask(this.pdfUrl);
    }
    this.checkPdfData();
  },
  methods: {
    changePdf() {
      this.isShowpdf = !this.isShowpdf;
    },
    chageFile(data) {},
    changePercent(data) {
      this.isLoading = true;
      this.videoUploadPercent = data;
      if (data > 90) {
        this.videoUploadPercent = 0;
        this.isLoading = false;
      }
    },
    checkPdfData() {
      var id = this.activePdf.invoiceDocumentFileId;
      if (!id) {
        this.isShowpdf = false;
        return;
      }
      var pdfUrl = fileuploadApi.getPdfUrl(id);
      this.src = pdfUrl + "#view=FitH";
    },
    updatePdf(params) {
      let option = {
        invoiceDocumentFile: params.file
      };

      receivableApi
        .uploadInvoice(this.activePdf.id, option)
        .then(res => {
          if (res && res.fileId) {
            this.pdfUrl = res.fileId;
            this.changePdf();
            let pafList = this.pafList;
            const rowIndex = pafList.findIndex(n => this.activePdf.id === n.id);
            pafList[rowIndex].invoiceDocumentFileId = res.fileId;
            pafList[rowIndex].invoiceDocumentFilename = res.fileName;
            let tableItemDetail = this.tableItemDetail;
            this.$store.dispatch("setActionActivePdf", pafList[rowIndex]);
            this.$store.dispatch("setActionPdfList", pafList);
            this.checkPdfData();
          }
          this.toastSuccess();
        })
        .catch(err => {
          this.toast(err);
          console.log("err", err);
        });
    }
  },
  computed: {
    ...mapGetters({
      activePdf: "activePdf",
      pafList: "pafList",
      tableItemDetail: "tableItemDetail"
    })
  },
  watch: {
    activePdf() {
      this.checkPdfData();
    }
  }
};
</script>
<style lang="scss" scoped>
.pdf_box {
  height: 100%;
  text-align: center;
  position: relative;
  .pdf_bg {
    position: relative;
    height: 100%;
    background: #eff0f1;
    .unpdf_Box {
      height: 100%;
      .file_box {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        .el-progress {
          background: rgba(0, 0, 0, 0.1) !important;
        }
      }
    }
    .fa-refresh {
      position: absolute;
      left: 0.7rem;
      top: 0.7rem;
      z-index: 99;
      font-size: 1.4rem;
      cursor: pointer;
    }
  }
}
.pdf_iframe {
  padding: 30px;
  width: 100%;
  height: 100%;
  background-color: #eff0f1;
  border-radius: 7px;
  position: relative;
  &:hover {
    .pdf_btn {
      opacity: 1;
      transition: opacity 1s;
    }
  }
  .pdf_btn {
    position: absolute;
    color: #0071eb;
    font-size: 80px;
    top: 50%;
    transform: translate(-50%, 0);
    z-index: 10;
    opacity: 0;
    cursor: pointer;
  }

  .pre_page {
    left: 1rem;
  }
  .next_page {
    right: -16px;
  }
}
</style>
